"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var react_1 = __importDefault(require("react"));
var main_1 = require("./screens/main");
var react_ga4_1 = __importDefault(require("react-ga4"));
var react_gtm_module_1 = __importDefault(require("react-gtm-module"));
var tagManagerArgs = {
    gtmId: (_a = process.env.GOOGLE_TAG_MANAGER_ID) !== null && _a !== void 0 ? _a : "",
    dataLayer: {
        userId: "001",
        userProject: "Ackermans",
    },
};
var App = function () {
    react_gtm_module_1.default.initialize(tagManagerArgs);
    react_ga4_1.default.initialize("".concat(process.env.GOOGLE_TRACKING_ID));
    return react_1.default.createElement(main_1.MainScreen, null);
    // return <MainTestScreen />;
};
exports.App = App;
